import { render } from "./other-funds.vue?vue&type=template&id=e63627cc&scoped=true"
import script from "./other-funds.vue?vue&type=script&lang=js"
export * from "./other-funds.vue?vue&type=script&lang=js"

import "./other-funds.vue?vue&type=style&index=0&id=e63627cc&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63627cc"]])

export default __exports__